export enum WidgetType {
  GENERAL = 'general',
  AUDIENCE = 'audience',
  TRAFFIC = 'traffic',
  FUNNEL = 'funnel',
  PERFORMANCE = 'performance',
  ACCOUNTING = 'accounting',
  SYSTEM = 'system',
  KPI = 'kpi',
}
